// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__3iW_I","info":"UpdateTermsInfo_info__q3KoT"};